import React from 'react';

const TimeZoneDropdown = ({ id, label, value, onChange, className }) => {
  // Get list of all time zones
  const timeZones = Intl.supportedValuesOf('timeZone');

  return (
    <div className={className}>
      <label htmlFor={id} className="form-label fw-bold">
        {label}
      </label>
      <select
        id={id}
        className="form-select"
        value={value}
        onChange={onChange}
      >
        <option value="">Select time zone</option>
        {timeZones.map(zone => (
          <option key={zone} value={zone}>
            {zone}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TimeZoneDropdown;
